interface Props {
  className: any;
}

export const Swapicon5 = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="42"
      viewBox="0 0 42 42"
      width="42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9145_20020)">
        <path
          d="M40.8594 16.4961V33.1523C40.8594 34.5697 39.7143 35.7148 38.2969 35.7148H3.70312C2.28574 35.7148 1.14062 34.5697 1.14062 33.1523V11.3711C1.14062 9.95371 2.28574 8.80859 3.70312 8.80859H30.6094"
          stroke="#46555E"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.53895"
        />

        <path
          d="M24.2031 35.7148H17.7969V40.8398H24.2031V35.7148Z"
          stroke="#46555E"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.53895"
        />

        <path
          d="M15.875 40.8398H26.125"
          stroke="#46555E"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.53895"
        />

        <path
          d="M39.5781 13.9336H34.4531C33.7484 13.9336 33.1719 13.357 33.1719 12.6523V2.40234C33.1719 1.69766 33.7484 1.12109 34.4531 1.12109H39.5781C40.2828 1.12109 40.8594 1.69766 40.8594 2.40234V12.6523C40.8594 13.357 40.2828 13.9336 39.5781 13.9336Z"
          stroke="#46555E"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.53895"
        />

        <path
          d="M35.7344 9.44922C36.0882 9.44922 36.375 9.1624 36.375 8.80859C36.375 8.45479 36.0882 8.16797 35.7344 8.16797C35.3806 8.16797 35.0938 8.45479 35.0938 8.80859C35.0938 9.1624 35.3806 9.44922 35.7344 9.44922Z"
          fill="#46555E"
        />

        <path
          d="M38.2969 9.44922C38.6507 9.44922 38.9375 9.1624 38.9375 8.80859C38.9375 8.45479 38.6507 8.16797 38.2969 8.16797C37.9431 8.16797 37.6562 8.45479 37.6562 8.80859C37.6562 9.1624 37.9431 9.44922 38.2969 9.44922Z"
          fill="#46555E"
        />

        <path
          d="M35.7344 6.88672C36.0882 6.88672 36.375 6.5999 36.375 6.24609C36.375 5.89229 36.0882 5.60547 35.7344 5.60547C35.3806 5.60547 35.0938 5.89229 35.0938 6.24609C35.0938 6.5999 35.3806 6.88672 35.7344 6.88672Z"
          fill="#46555E"
        />

        <path
          d="M38.2969 6.88672C38.6507 6.88672 38.9375 6.5999 38.9375 6.24609C38.9375 5.89229 38.6507 5.60547 38.2969 5.60547C37.9431 5.60547 37.6562 5.89229 37.6562 6.24609C37.6562 6.5999 37.9431 6.88672 38.2969 6.88672Z"
          fill="#46555E"
        />

        <path
          d="M35.7344 12.0117C36.0882 12.0117 36.375 11.7249 36.375 11.3711C36.375 11.0173 36.0882 10.7305 35.7344 10.7305C35.3806 10.7305 35.0938 11.0173 35.0938 11.3711C35.0938 11.7249 35.3806 12.0117 35.7344 12.0117Z"
          fill="#46555E"
        />

        <path
          d="M38.2969 12.0117C38.6507 12.0117 38.9375 11.7249 38.9375 11.3711C38.9375 11.0173 38.6507 10.7305 38.2969 10.7305C37.9431 10.7305 37.6562 11.0173 37.6562 11.3711C37.6562 11.7249 37.9431 12.0117 38.2969 12.0117Z"
          fill="#46555E"
        />
      </g>

      <defs>
        <clipPath id="clip0_9145_20020">
          <rect
            fill="white"
            height="41"
            transform="translate(0.5 0.480469)"
            width="41"
          />
        </clipPath>
      </defs>
    </svg>
  );
}; 